import { SALES } from "../../types/SaleType";

import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";

const getSaleAction = (data) => {
	return {
		type: SALES,
		payload: data,
	};
};

export const loadAllSale = ({ page, limit, startdate, enddate, user, customer }) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			// Convert dates to ISO format for API calls
			// Handle moment objects, Date objects, or strings
			let startDateISO = '';
			let endDateISO = '';
			
			if (startdate) {
				if (typeof startdate === 'object' && startdate.format) {
					// It's a moment object
					startDateISO = moment(startdate).format('YYYY-MM-DD');
				} else if (startdate instanceof Date) {
					startDateISO = moment(startdate).format('YYYY-MM-DD');
				} else {
					startDateISO = moment(startdate).format('YYYY-MM-DD');
				}
			}
			
			if (enddate) {
				if (typeof enddate === 'object' && enddate.format) {
					// It's a moment object
					endDateISO = moment(enddate).format('YYYY-MM-DD');
				} else if (enddate instanceof Date) {
					endDateISO = moment(enddate).format('YYYY-MM-DD');
				} else {
					endDateISO = moment(enddate).format('YYYY-MM-DD');
				}
			}

			const userParam = user != null && user !== "" ? user : "";
			const customerParam = customer != null && customer !== "" ? customer : "";
			const qs = `page=${page}&count=${limit}&startdate=${startDateISO}&enddate=${endDateISO}&user=${userParam}&customer=${customerParam}`;

			// Fetch all three types of documents in parallel
			const [salesData, quotationsData, challansData] = await Promise.all([
				axios.get(`sale-invoice?&${qs}`).catch((err) => { 
					console.error("Error fetching sales:", err);
					return { data: { allSaleInvoice: [], aggregations: null } };
				}),
				axios.get(`quotation?&${qs}`).catch((err) => { 
					console.error("Error fetching quotations:", err);
					return { data: [] };
				}),
				axios.get(`challan?&${qs}`).catch((err) => { 
					console.error("Error fetching challans:", err);
					return { data: [] };
				})
			]);

			// Add document type to each item
			// Sales API returns: {aggregations: {...}, allSaleInvoice: [...]}
			// Quotations and Challans return: [...]
			const sales = salesData.data?.allSaleInvoice ? salesData.data.allSaleInvoice.map(item => ({ ...item, document_type: 'sale' })) : [];
			// For quotations and challans, calculate due_amount and paid_amount since they don't have these fields
			// paid_amount is 0 (no payments), due_amount is total_amount - discount
			const quotations = Array.isArray(quotationsData.data) ? quotationsData.data.map(item => ({
				...item,
				document_type: 'quotation',
				bill_discount_amount: Number(item.discount || 0),
				paid_amount: 0,
				due_amount: (item.total_amount || 0) - (item.discount || 0)
			})) : [];
			const challans = Array.isArray(challansData.data) ? challansData.data.map(item => ({
				...item,
				document_type: 'challan',
				bill_discount_amount: Number(item.discount || 0),
				paid_amount: 0,
				due_amount: (item.total_amount || 0) - (item.discount || 0)
			})) : [];

			// Combine all documents
			const allDocuments = [...sales, ...quotations, ...challans];
			
			// Use aggregations from sales if available, otherwise calculate
			let total;
			if (salesData.data?.aggregations) {
				// Combine sales aggregations with quotations and challans data
				total = {
					_sum: {
						total_amount: (salesData.data.aggregations._sum?.total_amount || 0) + 
									   allDocuments.filter(d => d.document_type !== 'sale').reduce((sum, doc) => sum + (doc.total_amount || 0), 0),
						paid_amount: (salesData.data.aggregations._sum?.paid_amount || 0) + 
									  allDocuments.filter(d => d.document_type !== 'sale').reduce((sum, doc) => sum + (doc.paid_amount || 0), 0),
						due_amount: (salesData.data.aggregations._sum?.due_amount || 0) + 
									 allDocuments.filter(d => d.document_type !== 'sale').reduce((sum, doc) => sum + (doc.due_amount || 0), 0),
						discount: (salesData.data.aggregations._sum?.discount || 0) + 
								  allDocuments.filter(d => d.document_type !== 'sale').reduce((sum, doc) => sum + (doc.discount || 0), 0),
						profit: (salesData.data.aggregations._sum?.profit || 0) + 
								allDocuments.filter(d => d.document_type !== 'sale').reduce((sum, doc) => sum + (doc.profit || 0), 0),
					},
					_count: {
						id: allDocuments.length
					}
				};
			} else {
				// Calculate totals from all documents
				total = {
					_sum: {
						total_amount: allDocuments.reduce((sum, doc) => sum + (doc.total_amount || 0), 0),
						paid_amount: allDocuments.reduce((sum, doc) => sum + (doc.paid_amount || 0), 0),
						due_amount: allDocuments.reduce((sum, doc) => sum + (doc.due_amount || 0), 0),
						discount: allDocuments.reduce((sum, doc) => sum + (doc.discount || 0), 0),
						profit: allDocuments.reduce((sum, doc) => sum + (doc.profit || 0), 0),
					},
					_count: {
						id: allDocuments.length
					}
				};
			}

			// Format data to match what the reducer expects
			// Reducer expects: { allSaleInvoice: [...], aggregations: {...} }
			const combinedData = {
				allSaleInvoice: allDocuments,
				aggregations: total
			};

			//dispatching data
			dispatch(getSaleAction(combinedData));
			return {
				message: "success",
			};
		} catch (error) {
			console.log("loadAllSale error:", error.message);
			toast.error("Error in loading sales");
			// Dispatch empty data to clear loading state
			dispatch(getSaleAction({
				allSaleInvoice: [],
				aggregations: {
					_sum: {
						total_amount: 0,
						paid_amount: 0,
						due_amount: 0,
						discount: 0,
						profit: 0,
					},
					_count: {
						id: 0
					}
				}
			}));
			return {
				message: "error",
			};
		}
	};
};
